import createPropertiesSource from './createPropertiesSource'
import mergeStylesByBreakpoints from './mergeStylesByBreakpoints'
import migrateProperties from './migrateProperties'
import {parseStylableStyleItems} from './parseStylableStyleItems'
import {migratedStyleToStyleProperties} from './migratedStyleToStyleProperties'
import migrateStylableComponent from './migrateStylableComponent'

const stylableMigrationUtils = {
    createPropertiesSource,
    parseStylableStyleItems,
    migrateProperties,
    mergeStylesByBreakpoints,
    migratedStyleToStyleProperties,
    migrateStylableComponent
}

export {
    createPropertiesSource,
    parseStylableStyleItems,
    migrateProperties,
    mergeStylesByBreakpoints,
    migratedStyleToStyleProperties,
    migrateStylableComponent
}

export default stylableMigrationUtils
